import { render, staticRenderFns } from "./allOrders.vue?vue&type=template&id=b6111468"
import script from "./allOrders.vue?vue&type=script&lang=js"
export * from "./allOrders.vue?vue&type=script&lang=js"
import style0 from "./allOrders.vue?vue&type=style&index=0&id=b6111468&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports